import * as React from "react";
import { useState } from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Help from "@material-ui/icons/Help";

interface HelpIconTooltipProps {
  title: NonNullable<React.ReactNode>;
  fontSize?: string;
}

export function HelpIconTooltip({ title, fontSize = "12" }: HelpIconTooltipProps) {
  const [open, setOpen] = useState(false);
  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Tooltip
        onClose={onClose}
        placement={"right-start"}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={<span style={{ fontSize: `${fontSize}px` }}>{title}</span>}
      >
        <IconButton size={"small"} color="primary" onClick={onOpen}>
          <Help fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </ClickAwayListener>
  );
}
